// LICITAPRO — abertura do noVNC via SSO (FASE VNC-SSO / E15)
// ─────────────────────────────────────────────────────────────────────────
// O admin ja autenticado no painel pede um COOKIE curto ao backend
// (POST /api/vnc/session) e so entao navega para a rota CANONICA do target.
// Sem popup HTTP Basic, sem token na URL. A aba abre SINCRONA (no gesto do
// clique) para nao ser barrada por popup blocker; a navegacao acontece depois
// que o cookie ja foi setado. O -rfbauth do x11vnc continua sendo pedido pela
// tela.
//
// [E15] A URL e SEMPRE construida por buildVncUrl(target) — nunca herdada de
// `vnc.url`/prontidao (que ainda pode trazer a rota LEGADA /vnc/vnc.html com
// path=vnc/websockify, que faz o WebSocket apontar para o lugar errado).
import api from '../services/api';

export function buildVncUrl(target) {
  const alvo = target === 'standby' ? 'standby' : 'primary';
  return '/vnc/' + alvo + '/vnc.html'
    + '?autoconnect=true&resize=scale&reconnect=1&reconnect_delay=2000'
    + '&path=vnc/' + alvo + '/websockify';
}

export async function abrirVnc(target) {
  const alvo = target === 'standby' ? 'standby' : 'primary';
  const destino = buildVncUrl(alvo); // [E15] canonica, nunca a url legada herdada
  const aba = window.open('', '_blank');
  if (aba) { try { aba.opener = null; } catch (_e) { /* */ } }
  try {
    await api.post('/vnc/session', { target: alvo });
    if (aba) aba.location.href = destino;
    else window.location.href = destino;
  } catch (err) {
    if (aba) { try { aba.close(); } catch (_e) { /* */ } }
    const s = err && err.response && err.response.status;
    if (s === 403) { window.alert('Voce nao possui permissao para acessar o navegador remoto.'); return; }
    if (s === 401) { return; } // o interceptor do api ja leva ao login (sessao expirada)
    const detalhe = (err && err.response && err.response.data && err.response.data.detail) || (err && err.message) || 'erro';
    window.alert('Nao foi possivel abrir o navegador: ' + detalhe);
  }
}

export default abrirVnc;
